export class LoadDataCollections {
    public static readonly type = '[DataCollection] Load data collections';
}
